module.exports = __webpack_public_path__ + "static/media/health_care.3d32a817.jpg";